import React, { useEffect } from "react";
import { Link } from "../../design/link";
import { useMatter } from "../../contexts/MatterContext";
import { ChevronLeftIcon } from "@heroicons/react/20/solid";
import { Avatar } from "../../design/avatar";
import { useParams } from "react-router-dom";
import { Heading } from "../../design/heading";
import DeleteTeamMemberButton from "./components/DeleteTeamMemberButton";
import {
  DescriptionDetails,
  DescriptionList,
  DescriptionTerm,
} from "../../design/description-list";
import moment from "moment";
import TeamMemberRoleBadge from "../../components/TeamMemberRoleBadge";
import { useAuth } from "../../contexts/AuthContext";
import { useTeamMember } from "../../contexts/TeamMemberContext";
import Breadcrumbs from "../../components/Breadcrumbs";
import EditTeamMemberButton from "./components/EditTeamMemberButton";

const TeamMemberDetailPage: React.FC = () => {
  const { user } = useAuth();
  const { teamMemberId } = useParams<{ teamMemberId: string }>();
  const { teamMembers, currentTeamMember } = useTeamMember();

  const selectedTeamMember = teamMembers.find(
    (teamMember) => teamMember._id === teamMemberId,
  );

  return (
    <div>
      <Breadcrumbs
        items={[
          { label: "Team", href: "/memberships" },
          {
            label: selectedTeamMember?.user?.name ?? "Team Member",
            href: `/team-member/${selectedTeamMember?._id}`,
          },
        ]}
      />

      <div className="flex flex-col w-full gap-6 md:flex-row">
        {selectedTeamMember && (
          <div className="w-full gap-6">
            <div>
              <div className="flex items-end justify-between gap-4">
                <div className="flex gap-4">
                  {selectedTeamMember?.user?.avatarUrl && (
                    <Avatar
                      src={selectedTeamMember?.user.avatarUrl}
                      alt={selectedTeamMember.user.name}
                      className="w-12 h-12 rounded-full"
                    />
                  )}
                  <Heading>{selectedTeamMember.user?.name}</Heading>
                </div>
                <div className="flex gap-2">
                  {currentTeamMember?.role === "owner" &&
                    teamMemberId !== user?.uid && (
                      <DeleteTeamMemberButton teamMemberId={teamMemberId!} />
                    )}
                  <EditTeamMemberButton teamMember={selectedTeamMember!} />
                </div>
              </div>
              <div className="w-full mt-4">
                <DescriptionList>
                  {selectedTeamMember.createdAt && (
                    <>
                      <DescriptionTerm>Created</DescriptionTerm>
                      <DescriptionDetails>
                        {moment(selectedTeamMember.createdAt).format(
                          "MMMM D, YYYY",
                        )}
                      </DescriptionDetails>
                    </>
                  )}
                  <DescriptionTerm>Role</DescriptionTerm>
                  <DescriptionDetails>
                    <TeamMemberRoleBadge role={selectedTeamMember.role} />
                  </DescriptionDetails>
                </DescriptionList>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamMemberDetailPage;
